import { useQuery } from '@tanstack/react-query';

import { notificationsClient } from 'clients/NotificationsClient/NotificationsClient';
import { NylasServiceStatus } from 'clients/NotificationsClient/NotificationsClient.types';
import { isAxiosError } from 'helpers/clientHelpers';
import { AccountStatus } from 'shared/legacy/contexts/CandidateContext/CandidateEmailSettingsContext.types';
import { QueryKey } from 'types/query';
import { useCurrentUserQuery } from './useCurrentUserQuery';

type OauthNylasStatus = {
  email: AccountStatus;
  calendar: AccountStatus;
};

const mapStatus = (status?: NylasServiceStatus): AccountStatus => {
  if (status === 'valid') return AccountStatus.Valid;
  if (status === 'invalid') return AccountStatus.Invalid;

  return AccountStatus.NonExistent;
};

export const useOauthNylasStatusQuery = () => {
  const { data: currentUser } = useCurrentUserQuery();

  return useQuery<OauthNylasStatus>(
    [QueryKey.useOauthNylasStatusQuery, currentUser?.email],
    async () => {
      try {
        const { data } = await notificationsClient.connectedEmailAccountStatus();

        return {
          email: mapStatus(data.email?.status),
          calendar: mapStatus(data.calendar?.status),
        };
      } catch (e) {
        if (isAxiosError(e) && e.response?.status === 404) {
          return {
            email: AccountStatus.NonExistent,
            calendar: AccountStatus.NonExistent,
          };
        }

        throw e;
      }
    },
    { enabled: !!currentUser, retry: false },
  );
};
